module.exports = __webpack_public_path__ + "assets/img/3021.0247a473.png";